/** The database ontrack used before sign-in was required, and still uses in local development. */
export const SHARED_DATABASE = "otrack";
const SHARED_OWNER_KEY = "otrack-shared-database-owner";

export interface DatabaseLookup {
  /** Whether the browser already has a database with this name. */
  exists(name: string): Promise<boolean>;
  storage: Pick<Storage, "getItem" | "setItem">;
}

/**
 * The IndexedDB database that holds an account's data on this device. Each account gets its own,
 * so signing in as someone else never shows, or syncs, what the previous account left here. Data
 * saved before sign-in was required stays with the first account that signs in on the device.
 */
export async function accountDatabase(userId: string, lookup: DatabaseLookup): Promise<string> {
  const owner = lookup.storage.getItem(SHARED_OWNER_KEY);
  if (owner === userId) return SHARED_DATABASE;
  if (owner === null && await lookup.exists(SHARED_DATABASE)) {
    lookup.storage.setItem(SHARED_OWNER_KEY, userId);
    return SHARED_DATABASE;
  }
  return `${SHARED_DATABASE}-${userId}`;
}
